var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DxNumberBox',{style:({
      width: (Math.round(_vm.value).toString().length + _vm.length) * 8 + 2 + 'px',
    }),attrs:{"value":_vm.value,"format":_vm.getDecimalFormatByName(_vm.format).Format,"disabled":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }